import { BackendErrorPayload } from '@paywithextend/components/dist/error.utils'
import {
  AttachmentConnectedPlatformListResponse,
  ReceiptAttachmentResponse,
} from 'src/models/receiptAttachment.models'

export const UPLOAD_ATTACHMENT_INIT =
  'data/receiptAttachments/UPLOAD_ATTACHMENT_INIT'
export const UPLOAD_ATTACHMENT_SUCCESS =
  'data/receiptAttachments/UPLOAD_ATTACHMENT_SUCCESS'
export const UPLOAD_ATTACHMENT_FAILURE =
  'data/receiptAttachments/UPLOAD_ATTACHMENT_FAILURE'

export type UploadAttachmentInitPayload = {
  uploadId: string
  thumbnailUrl: string
  fileName: string
}
export type UploadAttachmentSuccessPayload = ReceiptAttachmentResponse & {
  uploadId: string
}
export type UploadAttachmentFailurePayload = {
  uploadId: string
}
export interface UploadAttachmentInitAction {
  type: typeof UPLOAD_ATTACHMENT_INIT
  payload: UploadAttachmentInitPayload
}
export interface UploadAttachmentSuccessAction {
  type: typeof UPLOAD_ATTACHMENT_SUCCESS
  payload: UploadAttachmentSuccessPayload
}
export interface UploadAttachmentFailureAction {
  type: typeof UPLOAD_ATTACHMENT_FAILURE
  payload: UploadAttachmentFailurePayload
}

export type UploadAttachmentActions =
  | UploadAttachmentInitAction
  | UploadAttachmentSuccessAction
  | UploadAttachmentFailureAction

export const createUploadAttachmentInitAction = (
  payload: UploadAttachmentInitPayload,
): UploadAttachmentInitAction => ({
  type: UPLOAD_ATTACHMENT_INIT,
  payload,
})

export const createUploadAttachmentSuccessAction = (
  payload: UploadAttachmentSuccessPayload,
): UploadAttachmentSuccessAction => ({
  type: UPLOAD_ATTACHMENT_SUCCESS,
  payload,
})

export const createUploadAttachmentFailureAction = (
  payload: UploadAttachmentFailurePayload,
): UploadAttachmentFailureAction => ({
  type: UPLOAD_ATTACHMENT_FAILURE,
  payload,
})

export const POST_ERP_RECEIPT_ATTACHMENTS_INIT =
  'data/receiptAttachments/POST_ERP_RECEIPT_ATTACHMENTS_INIT'
export const POST_ERP_RECEIPT_ATTACHMENTS_SUCCESS =
  'data/receiptAttachments/POST_ERP_RECEIPT_ATTACHMENTS_SUCCESS'
export const POST_ERP_RECEIPT_ATTACHMENTS_FAILURE =
  'data/receiptAttachments/POST_ERP_RECEIPT_ATTACHMENTS_FAILURE'

export type PostERPReceiptAttachmentsSuccessPayload = {
  transactionId: string
  receiptAttachments: AttachmentConnectedPlatformListResponse[]
}
export type PostERPReceiptAttachmentsFailurePayload = {
  transactionId: string
  errors: BackendErrorPayload<string>
}

export interface PostERPReceiptAttachmentsInitAction {
  type: typeof POST_ERP_RECEIPT_ATTACHMENTS_INIT
}
export interface PostERPReceiptAttachmentsSuccessAction {
  type: typeof POST_ERP_RECEIPT_ATTACHMENTS_SUCCESS
  payload: PostERPReceiptAttachmentsSuccessPayload
}
export interface PostERPReceiptAttachmentsFailureAction {
  type: typeof POST_ERP_RECEIPT_ATTACHMENTS_FAILURE
  payload: PostERPReceiptAttachmentsFailurePayload
}

export type PostERPReceiptAttachmentsActions =
  | PostERPReceiptAttachmentsInitAction
  | PostERPReceiptAttachmentsSuccessAction
  | PostERPReceiptAttachmentsFailureAction

export const createPostERPReceiptAttachmentsInitAction =
  (): PostERPReceiptAttachmentsInitAction => ({
    type: POST_ERP_RECEIPT_ATTACHMENTS_INIT,
  })

export const createPostERPReceiptAttachmentsSuccessAction = (
  payload: PostERPReceiptAttachmentsSuccessPayload,
): PostERPReceiptAttachmentsSuccessAction => ({
  type: POST_ERP_RECEIPT_ATTACHMENTS_SUCCESS,
  payload,
})

export const createPostERPReceiptAttachmentsFailureAction = (
  payload: PostERPReceiptAttachmentsFailurePayload,
): PostERPReceiptAttachmentsFailureAction => ({
  type: POST_ERP_RECEIPT_ATTACHMENTS_FAILURE,
  payload,
})
